<template>
  <div>
    <div class="select-wrapper" style="display:inline">
      <b-form-group 
        label="Show" 
        label-cols="auto" 
        label-for="filterByStatus"
        label-class="mb-0" 
        class="d-flex align-items-center"
      >
        <b-form-select v-model="actionsSelection" id="filterByStatus">
          <option value="Open">Open</option>
          <option value="All">All</option>
        </b-form-select>
      </b-form-group>
    </div>
    <ProjectMetricActions
      :projectMetrics="visibleActionItems"
      :possibleAssignees="possibleAssignees"
      @refresh="refreshSpecificProjectMetric"
    ></ProjectMetricActions>
    <div class="mt-0 btn-wrapper">
      <b-button
        v-if="lengthCheck > optionLength"
        @click="showMore()"
        variant="tertiary"
        class="view"
      >
        Show more
      </b-button>
    </div>
  </div>
</template>

<script>
import ProjectMetricActions from "@/components/list-entries/ProjectMetricActions.vue";

export default {
  name: "ProjectMetricActionItems",
  components: {
    ProjectMetricActions,
  },
  props: {
    actionItems: {
      type: Array,
      default: () => [],
    },
    possibleAssignees: { type: Array, default: () => [] },
  },
  data() {
    return {
      length: 6,
      openLength: 6,
      allLength: 6,
      actionsSelection: "Open",
    };
  },
  methods: {
    refreshSpecificProjectMetric(id) {
      this.$emit("refresh", id);
    },
    showMore() {
      if (this.actionsSelection == "Open") {
        this.openLength += this.length;
      } else {
        this.allLength += this.length;
      }
    },
    sortByRisk: (a, b) => {
      if (a.type > b.type) return -1;
      if (a.type < b.type) return 1;

      if (a.dateCreated > b.dateCreated) return -1;
      if (a.dateCreated < b.dateCreated) return 1;
      return 0;
    },
    calcDaysOpen(p) {
      let todaysDate = new Date();
      let startDate = new Date(
        p.dateCreated != null
          ? p.dateCreated
          : p.dateIdentified != null
          ? p.dateIdentified
          : new Date()
      );
      //Logic to check for the amount of openDays
      let resolveDate = new Date(
        p.dateResolved != null
          ? p.dateResolved
          : p.dateClosed != null
          ? p.dateClosed
          : new Date()
      );
      if (todaysDate.getTime() >= resolveDate.getTime()) {
        let todayTimeOpen = resolveDate.getTime() - startDate.getTime();
        let todayShownTime = Math.ceil(todayTimeOpen / (1000 * 3600 * 24));
        return todayShownTime > 0 ? todayShownTime : 1;
      } else {
        let timeOpen = todaysDate.getTime() - startDate.getTime();
        let shownTime = Math.ceil(timeOpen / (1000 * 3600 * 24));
        return shownTime > 0 ? shownTime : 1;
      }
    },
    isItOverDue(due) {
      //logic to check if it is overDue
      let result = false;
      if (due.dateDue != null) {
        let todaysDate = new Date();
        let dateDue = new Date(
          due.dateDue != null ? due.dateDue : new Date()
        );
        if (
          todaysDate.getTime() > dateDue.getTime() &&
          (due.dateResolved == null || due.dateClosed == null)
        ) {
          result = true;
        } else {
          result = false;
        }
      }
      return result
    },
  },
  computed: {
    allVisibleActionItems() {
      if (this.actionsSelection === "Open") {
        return this.openItems;
      } else return this.allItems;
    },
    visibleActionItems() {
      if (this.actionsSelection === "Open") {
        return this.openItems
          .map((item) => ({
            ...item,
            daysOpen: this.calcDaysOpen(item),
            overDue: this.isItOverDue(item),
          }))
          .slice(0, this.openLength);
      } else
        return this.allItems
          .map((item) => ({
            ...item,
            daysOpen: this.calcDaysOpen(item),
            overDue: this.isItOverDue(item),
          }))
          .slice(0, this.allLength);
    },
    openItems() {
      return this.actionItems
        .filter((p) => p.status == "Open")
        .sort(this.sortByRisk);
    },
    closedItems() {
      return this.actionItems
        .filter((p) => p.status == "Closed")
        .sort(this.sortByRisk);
    },
    allItems() {
      let open = this.openItems;
      let close = this.closedItems;

      let all = open.concat(close);
      return all;
    },
    lengthCheck() {
      if (this.actionsSelection == "Open") return this.openItems.length;
      return this.actionItems.length;
    },
    optionLength() {
      if (this.actionsSelection == "Open") return this.openLength;
      return this.allLength;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>